export default __webpack_public_path__ + "static/media/image-work-company-m@2x.f6b97ccb.webp";